export default [
    {
        path:'/Appdownload',
        component: resolve => require(['../../../view/find/appdownload/down.vue'], resolve),
    }
]


// WEBPACK FOOTER //
// ./src/router/find/down/index.js